/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { useUrlGenerator } from '../../contexts/RoutesContext';

import Body from '../partials/Body';

import styles from '../../../styles/blocks/link.module.scss';

const propTypes = {
    body: PropTypes.string,
    route: PropTypes.shape({
        text: PropTypes.string,
        route: PropTypes.shape({
            name: PropTypes.string,
            props: PropTypes.object, // eslint-disable-line
        }),
    }),

    className: PropTypes.string,
};

const defaultProps = {
    body: null,
    route: null,
    className: null,
};

const LinkBlock = ({ body, route, className }) => {
    const url = useUrlGenerator();
    const { name, props } = route || {};
    return body !== null && name && props ? (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Link to={url(name, props)}>
                <Body body={body} />
            </Link>
        </div>
    ) : null;
};

LinkBlock.propTypes = propTypes;
LinkBlock.defaultProps = defaultProps;

export default LinkBlock;
